/* eslint-disable */

export const handleLabEntryValidation = (formData) => {
    const errors = {};
  
    const requiredFields = ['observedValue',];
  
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        errors[field] = `${field} is required`;
      }
    });
  
    // Return true if there are no errors
    return {
      isValid: Object.keys(errors).length === 0,
      errors,
    };
  };
  